import { render } from "./AchievementPopup.vue?vue&type=template&id=350201d8&scoped=true"
import script from "./AchievementPopup.vue?vue&type=script&lang=js"
export * from "./AchievementPopup.vue?vue&type=script&lang=js"

import "./AchievementPopup.vue?vue&type=style&index=0&id=350201d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350201d8"]])

export default __exports__